













































import Modal from '@/project/modals/Modal.vue';
import { Component, Prop } from 'vue-property-decorator';
import { BrandLogoViewModel, ImageViewObject, VideoViewObject } from '@/types/apiServerContract';
import ProductDetailsImageVideo from './ProductDetailsImageVideo.vue';
import { PageName } from '@/router/routes/constants';

@Component({
    components: { ProductDetailsImageVideo }
})
export default class ProductDetailsMediaOverlay extends Modal {
    @Prop({ type: Array, required: true })
    images!: ImageViewObject[];

    @Prop({ type: Array, required: true })
    videos!: VideoViewObject[];

    @Prop({ required: false })
    brandLogos!: BrandLogoViewModel;

    @Prop({ required: false })
    brandName!: string;

    @Prop({ type: Number, default: 16 / 9 })
    aspectRatio!: number;

    @Prop({ type: Number, default: 0 })
    activeIndex!: number;

    @Prop({ type: String, required: true })
    productName!: string;

    @Prop({ type: Object, required: true })
    thumbs!: any; // Swiper

    get id() {
        return new Date().valueOf();
    }

    get prevButtonSelector() {
        return 'custom-swiper-button-prev-' + this.id;
    }

    get nextButtonSelector() {
        return 'custom-swiper-button-next-' + this.id;
    }

    get sliderOptions() {
        return {
            initialSlide: this.activeIndex,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            loopFillGroupWithBlank: false,
            watchSlidesVisibility: true,
            watchOverflow: true,
            setWrapperSize: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.' + this.nextButtonSelector,
                prevEl: '.' + this.prevButtonSelector
            },
            grabCursor: true,
            keyboard: {
                enabled: true,
                onlyInViewPort: true
            },
            controller: {
                control: this.thumbs.$swiper
            }
        };
    }

    get style(): object {
        const padding = `${(100 / this.aspectRatio).toFixed(2)}%`;
        return { paddingTop: padding };
    }

    get brandPage() {
        return PageName.BRAND;
    }

    $refs!: Vue['$refs'] & {
        slider: any // todo: typesafety
    }
}
